import React from 'react';
import { Switch } from '@mui/material';
import styles from './Toggle.module.scss';

type OwnProps = {
  value?: any;
  defaultChecked?: boolean;
  testId?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const Toggle = (props: OwnProps) => {
  const { value, defaultChecked, testId, onChange } = props;

  return (
    <Switch
      value={value}
      defaultChecked={defaultChecked}
      onChange={onChange}
      data-test-id={testId}
      className={styles.switch}
    />
  );
};
